import React, { Component } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import {
    duplicateProduct,
    findProducts,
    loadBrands,
    loadCountries,
    loadDimensions,
    loadProductGroups,
    loadSuppliers,
    updateProduct
} from "../../reducer/actions";
import {
    getBrands,
    getCountries,
    getDimensions,
    getErrors,
    getProductGroups,
    getProducts,
    getSuppliers,
    isLoading
} from "../../reducer";
import ProductsTable from "./components/ProductsTable";
import SearchProduct from "./components/SearchProduct";
import DuplicateProductForm from "./components/DuplicateProductForm";
import EditProductForm from "./components/EditProductForm";
import { Container, Header, Icon, Message, Segment } from "semantic-ui-react";
import { push } from "react-router-redux";
import { hasPermission } from "../../../../reducer";

const requiredAttributes = [
    "alkohol",
    "empfehlung",
    "gewichting",
    "bestelleinheit",
    "region",
    "lagerfaehigkeit",
    "barrique",
    "schwere",
    "traubensorte",
    "herkunftsbezeichnung",
    "jahrgang",
    "holzkiste"
];

class ManageProducts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            codeOld: "",
            code: "",
            products: null,
            selectedProduct: null,
            method: null,
            dimensions: null,
            oldProductId: null,
            createMatrix: false
        };
    }

    componentDidMount() {
        if (!this.props.hasPermission) {
            return this.props.redirectNoPermission();
        }
        this.props.loadDimensions();
        this.props.loadProductGroups();
        this.props.loadSuppliers();
        this.props.loadCountries();
        this.props.loadBrands();
    }


    prepareAttributes(product, method = "duplicate") {
        let attributes = product.product_attributes;
        let foundRequiredAttributes = [];
        for (let key in attributes) {
            if (requiredAttributes.indexOf(attributes[key].name) > -1) {
                foundRequiredAttributes.push(attributes[key].name);
            }
        }

        for (let key in requiredAttributes) {
            if (foundRequiredAttributes.indexOf(requiredAttributes[key]) <= -1) {
                attributes.push({
                    name: requiredAttributes[key],
                    value: ""
                });
            }
        }

        if (product.price_lists.length === 0) {
            product.price_lists = [
                {
                    name: "Gastropreise",
                    pricelistID: 2,
                    pivot: {
                        price: product.priceWithVat
                    },
                    id: 5
                }
            ];
        }


        this.setState({
            oldProductId: product.id,
            selectedProduct: {
                ...product,
                product_attributes: attributes
            },
            createMatrix: false,
            method
        });
    }

    init(code) {
        this.loadProduct(code);
    }

    loadProduct(code) {
        this.props.findProducts(code);
    }

    render() {
        return (
            <Container>
                <Header as='h2' icon textAlign='center'>
                    <Icon name='plus' circular/>
                    <Header.Content>{this.props.translate("tools.manageProducts.header")}</Header.Content>
                </Header>

                {this.props.errors.length > 0 &&
                <Message
                    error
                    header={this.props.translate("general.thereWereErrors")}
                    list={this.props.errors}
                />
                }

                {this.props.products.length === 0 &&
                <Segment>
                    <SearchProduct onSearch={(code) => {
                        this.init(code);
                    }}/>
                </Segment>
                }

                {this.props.products.length > 0 && !this.state.selectedProduct &&
                <Segment>
                    <ProductsTable productSelected={(product) => {
                        this.prepareAttributes(product);
                    }}
                                   productSelectedForEdit={(product) => {
                                       this.prepareAttributes(product, "edit");
                                   }}
                    />
                </Segment>
                }

                {
                    this.state.selectedProduct && this.state.method === "duplicate" &&
                    <Segment>
                        <DuplicateProductForm
                            product={this.state.selectedProduct}
                            onSubmit={(request) => {
                                this.props.duplicateProduct(this.state.selectedProduct.id, request)
                                    .then(() => {
                                        if (this.props.errors.length === 0) {
                                            this.setState({
                                                selectedProduct: null,
                                                code: "",
                                                codeOld: "",
                                                method: null
                                            });
                                        }
                                    });
                            }}
                            {...this.props}
                        />
                    </Segment>
                }
                {
                    this.state.selectedProduct && this.state.method === "edit" &&

                    <Segment>
                        <EditProductForm
                            product={this.state.selectedProduct}
                            onSubmit={(request) => {
                                this.props.updateProduct(this.state.selectedProduct.id, request)
                                    .then(() => {
                                        if (this.props.errors.length === 0) {
                                            this.setState({
                                                selectedProduct: null,
                                                code: "",
                                                codeOld: "",
                                                method: null
                                            });
                                        }
                                    });
                            }}
                            {...this.props}
                        />
                    </Segment>
                }
            </Container>
        );
    }
}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    isLoading: isLoading(state.tools),
    dimensions: getDimensions(state.tools),
    productGroups: getProductGroups(state.tools),
    products: getProducts(state.tools),
    suppliers: getSuppliers(state.tools),
    countries: getCountries(state.tools),
    brands: getBrands(state.tools),
    errors: getErrors(state.tools),
    hasPermission: hasPermission(state, "masterDataManage")
});


const mapDispatchToProps = (dispatch) => {
    return ({
        loadDimensions: () => (dispatch(loadDimensions())),
        findProducts: (code) => (dispatch(findProducts(code))),
        loadProductGroups: () => (dispatch(loadProductGroups())),
        loadSuppliers: () => (dispatch(loadSuppliers())),
        loadBrands: () => (dispatch(loadBrands())),
        loadCountries: () => (dispatch(loadCountries())),
        duplicateProduct: (id, request) => (dispatch(duplicateProduct(id, request))),
        updateProduct: (id, request) => (dispatch(updateProduct(id, request))),
        redirectNoPermission: () => (dispatch(push("/")))

    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ManageProducts);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/ManageProducts/index.js